(function () {
  var GIFT_ENABLED = true; // master off-switch — flip to true to re-enable the free gift promo

  // Tier 1 (200g BAR45 @ ₹1500) removed. TIER1_ID stays ONLY in GIFT_IDS below so any
  // stray tier-1 line already sitting in a shopper's cart is excluded from subtotal and
  // stripped out by syncGifts() as "not wanted" — it is not used to add/target a gift.
  var TIER1_ID = 49941255586069;   // 200g BAR45 (legacy — also referenced by hidden Tier 3A)
  var TIER2_ID = 50308628218133;   // The BAR Celebration Box (Pack of 4)
  // 400g BAR45 (previous ₹2500 gift) — kept ONLY in GIFT_IDS so a stray leftover line is
  // excluded from subtotal and auto-removed by syncGifts().
  var OLD_TIER2_ID = 49941255618837;
  var TIER3B_ID = 49941256405269;  // Bean2BAR50 (paired with TIER1_ID at Tier 3, hidden)
  var TIER2_THRESHOLD = 250000;    // ₹2500 in paise
  var TIER3_THRESHOLD = 350000;    // ₹3500 in paise
  var GIFT_IDS = new Set([TIER1_ID, TIER2_ID, OLD_TIER2_ID, TIER3B_ID]);

  var isSyncing = false;
  var pendingSync = false;

  // Remembers gift variants that recently failed to add (e.g. out of stock) so a
  // persistent failure doesn't retry-loop on every sync — see isGiftUnavailable().
  var GIFT_UNAVAILABLE_COOLDOWN_MS = 5 * 60 * 1000; // 5 minutes
  var unavailableGifts = {}; // variantId -> timestamp of last failed add attempt

  function isGiftUnavailable(variantId) {
    var failedAt = unavailableGifts[variantId];
    return typeof failedAt === 'number' && (Date.now() - failedAt) < GIFT_UNAVAILABLE_COOLDOWN_MS;
  }

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' → ' + res.status);
      return res.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  // Signals the checkout gate (assets/cart-checkout-gate.js). 'giftSyncPending'
  // is fired the moment a sync becomes imminent (before the 400ms debounce);
  // 'giftSyncDone' when the episode — including any coalesced re-run — has fully
  // settled. No timing constant is shared between the two files.
  function emitGiftSync(key) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS[key]) {
      publish(PUB_SUB_EVENTS[key], { source: 'gift-progress' });
    }
  }

  function subtotalExGifts(cart) {
    return cart.items.reduce(function (sum, item) {
      return GIFT_IDS.has(item.variant_id) ? sum : sum + item.original_line_price;
    }, 0);
  }

  function currentGiftItems(cart) {
    return cart.items.filter(function (i) { return GIFT_IDS.has(i.variant_id); });
  }

  // Returns array of variant IDs that should be in the cart as gifts
  function targetGiftIds(subtotal) {
    // ponytail: tier3 (₹3500, 200g BAR45 + Bean2BAR50) hidden — restore next line to re-enable
    // if (subtotal >= TIER3_THRESHOLD) return [TIER1_ID, TIER3B_ID];
    if (subtotal >= TIER2_THRESHOLD) return [TIER2_ID];             // Celebration Box (Pack of 4)
    return [];
  }

  function updateUI(subtotal) {
    // Single tier only (₹2500 / Celebration Box) — progress runs 0–100% up to that threshold.
    var pct = subtotal >= TIER2_THRESHOLD
      ? 100
      : Math.floor(subtotal * 100 / TIER2_THRESHOLD);

    document.querySelectorAll('.gift-progress__bar').forEach(function (bar) {
      bar.style.width = pct + '%';
    });

    document.querySelectorAll('.gift-progress__track').forEach(function (track) {
      track.setAttribute('aria-valuenow', pct);
    });

    // Rupees still needed, rounded up — formatted to match the Liquid render in snippets/gift-progress.liquid
    var left = Math.ceil(Math.max(TIER2_THRESHOLD - subtotal, 0) / 100).toLocaleString('en-IN');
    document.querySelectorAll('[data-gift-left]').forEach(function (el) {
      el.textContent = left;
    });

    document.querySelectorAll('.gift-progress').forEach(function (el) {
      el.classList.toggle('gift-progress--unlocked', subtotal >= TIER2_THRESHOLD);
    });
  }

  // GA4 / Meta event when the free gift lands in the cart, so the promo's AOV impact can be measured.
  // Once per session, same as the confetti.
  function trackGiftUnlocked(subtotal) {
    try {
      if (sessionStorage.getItem('bc_gift_tracked')) return;
      sessionStorage.setItem('bc_gift_tracked', '1');
    } catch (e) {}
    var value = subtotal / 100;
    if (typeof gtag === 'function') {
      gtag('event', 'free_gift_unlocked', { gift: 'Celebration Box', value: value, currency: 'INR' });
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'free_gift_unlocked', gift: 'Celebration Box', value: value, currency: 'INR' });
    }
    if (typeof fbq === 'function') {
      fbq('trackCustom', 'FreeGiftUnlocked', { gift: 'Celebration Box', value: value, currency: 'INR' });
    }
  }

  function markGiftsVerified() {
    document.querySelectorAll('.cart-item--gift').forEach(function (el) {
      el.classList.add('gift-verified');
    });
  }

  // ── Gift sync ───────────────────────────────────────

  function syncGifts() {
    if (isSyncing) { pendingSync = true; return; }
    isSyncing = true;
    pendingSync = false;

    var runSync = function () {
      return getCart()
        .then(function (cart) {
          var subtotal = subtotalExGifts(cart);
          var currentGifts = currentGiftItems(cart);
          var wanted = targetGiftIds(subtotal);
          // Gifts that recently failed to add (e.g. out of stock) are excluded from what
          // we treat as "correct" so we stop retrying them every sync — see
          // isGiftUnavailable() and the add-failure handler below.
          var effectiveWanted = wanted.filter(function (id) { return !isGiftUnavailable(id); });

          var currentIds = currentGifts.map(function (i) { return i.variant_id; }).sort();
          var effectiveWantedSorted = effectiveWanted.slice().sort();
          // A gift line must always be quantity 1. A race between a shopper's rapid
          // quantity change (which sends a now-stale line number to /cart/change.js)
          // and a concurrent gift add/remove can land that quantity on the gift line,
          // inflating it to match the real item (e.g. 10). Treat any gift qty != 1 as
          // "not correct" so the sync below clamps it back down.
          var giftQtysAllOne = currentGifts.every(function (i) { return i.quantity === 1; });
          var isCorrect = giftQtysAllOne &&
            currentIds.length === effectiveWantedSorted.length &&
            currentIds.every(function (id, idx) { return id === effectiveWantedSorted[idx]; });

          if (isCorrect) {
            markGiftsVerified();
            return Promise.resolve();
          }

          var chain = Promise.resolve();

          // Remove gifts not in wanted — use variant id to avoid stale line numbers
          currentGifts.forEach(function (gift) {
            if (wanted.indexOf(gift.variant_id) === -1) {
              chain = chain.then(function () {
                return post('/cart/change.js', { id: String(gift.variant_id), quantity: 0 });
              });
            }
          });

          // Hard-limit every kept gift line to exactly quantity 1. If a race inflated
          // it (e.g. shopper bumped a real item to 10 and a stale line number hit the
          // gift line instead), force it back to 1 by variant id.
          currentGifts.forEach(function (gift) {
            if (wanted.indexOf(gift.variant_id) !== -1 && gift.quantity !== 1) {
              chain = chain.then(function () {
                return post('/cart/change.js', { id: String(gift.variant_id), quantity: 1 });
              });
            }
          });

          // Add wanted gifts not already in cart — skip any variant that recently failed
          // to add (see effectiveWanted above), so a persistent failure (e.g. sold out)
          // doesn't retry-loop on every sync.
          var currentVariantIds = currentGifts.map(function (i) { return i.variant_id; });
          var toAdd = effectiveWanted.filter(function (id) { return currentVariantIds.indexOf(id) === -1; });
          if (toAdd.length > 0) {
            chain = chain.then(function () {
              return post('/cart/add.js', {
                items: toAdd.map(function (id) {
                  return { id: id, quantity: 1, properties: { _gift: 'true' } };
                }),
              }).catch(function (err) {
                var failedAt = Date.now();
                toAdd.forEach(function (id) { unavailableGifts[id] = failedAt; });
                throw err;
              });
            });
          }

          var tierLevel = subtotal >= TIER2_THRESHOLD ? 2 : 0; // ponytail: tier3 hidden; tier1 removed

          return chain.then(function () {
            var cartUrl = (typeof routes !== 'undefined' && routes.cart_url) || '/cart';
            return fetch(cartUrl + '?section_id=cart-drawer')
              .then(function (res) { return res.text(); })
              .then(function (text) {
                var html = new DOMParser().parseFromString(text, 'text/html');
                var targetInner = document.querySelector('#CartDrawer .drawer__inner');
                var sourceInner = html.querySelector('.drawer__inner');
                if (sourceInner) {
                  sourceInner.querySelectorAll('.cart-item--gift').forEach(function (el) {
                    el.classList.add('gift-verified');
                  });
                }
                if (targetInner && sourceInner) {
                  targetInner.innerHTML = sourceInner.innerHTML;
                }
                var cartDrawer = document.querySelector('cart-drawer');
                var sourceDrawer = html.querySelector('cart-drawer');
                if (cartDrawer && sourceDrawer) {
                  cartDrawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
                }
                markGiftsVerified();
                if (tierLevel > 0 && typeof window.bcFireGiftConfetti === 'function') {
                  window.bcFireGiftConfetti(tierLevel);
                }
                if (tierLevel > 0 && toAdd.length > 0) trackGiftUnlocked(subtotal);
                var iconBubble = document.getElementById('cart-icon-bubble');
                if (iconBubble) {
                  var rootUrl = (typeof routes !== 'undefined' && routes.root) || '/';
                  fetch(rootUrl + '?section_id=cart-icon-bubble')
                    .then(function (r) { return r.text(); })
                    .then(function (t) {
                      var iconHtml = new DOMParser().parseFromString(t, 'text/html');
                      var src = iconHtml.querySelector('.shopify-section');
                      if (src) iconBubble.innerHTML = src.innerHTML;
                    });
                }
              });
          });
        })
        .catch(function (err) {
          console.error('[gift-progress]', err);
        });
    };

    // Run the actual reads/writes under the shared cart lock so this never interleaves
    // with a shopper-initiated quantity/remove request in cart.js.
    var lock = typeof withCartLock === 'function' ? withCartLock(runSync) : runSync();
    lock.then(finalizeSync, finalizeSync);
  }

  function finalizeSync() {
    isSyncing = false;
    if (pendingSync) {
      // Another change landed mid-sync — run once more; the gate stays closed
      // until this whole chain settles (giftSyncDone is emitted below only when
      // there is nothing left to re-run).
      syncGifts();
    } else {
      emitGiftSync('giftSyncDone');
    }
  }

  function init() {
    if (!GIFT_ENABLED) return;

    getCart().then(function (cart) {
      updateUI(subtotalExGifts(cart));
    });
    syncGifts();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // A burst of quick quantity changes each publish their own cartUpdate event.
      // Debounce so that burst triggers one gift-sync after things settle, instead of
      // one background add/remove round-trip (and full drawer re-render) per change.
      var runGiftSync = function () {
        getCart().then(function (cart) {
          updateUI(subtotalExGifts(cart));
        });
        syncGifts();
      };
      var debouncedGiftSync = typeof debounce === 'function' ? debounce(runGiftSync, 400) : runGiftSync;

      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === 'gift-progress') return;
        // Tell the checkout gate a sync is imminent so it holds Checkout closed
        // through the debounce window below, not just while the sync runs.
        emitGiftSync('giftSyncPending');
        debouncedGiftSync();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
